export default ({...props}) => {
  const {space} = props.theme
  return `
        padding: ${space(2.5)}px;
        align-items: center;
        &[ap_type="gridAccordionTitle"]{
            padding: 0px;
            margin: 0px;
            & > p {
                margin: 0px;
            }
            &:last-child{
                display: flex;
                justify-content: flex-end;
            }
        }
        &[ap_type="gridAccordionDetailsWrapper"]{
            width: 100%;
            margin: 0px;
            padding: 0px;
            align-items: flex-start;
        }
        &[ap_type="gridAccordionDetails"]{
            margin: 0px;
            padding: 0px;
            &:last-child{
                text-align: right;
            }
        }
        &[ap_type="itemsRight"] {
            display: flex;
            justify-content: flex-end;
        }
    `
}
